import { mapState } from 'pinia';
import { getMultilangLink } from '@/utils/links';

/**
 * @deprecated Use `Links` composable instead
 */
export default {
  props: {
    to: {
      required: false,
      type: [String, Object],
    },
  },
  computed: {
    ...mapState(useMainStore, {
      isMultilang: 'isMultilang',
      getUrlPrefix: 'getUrlPrefix',
    }),
    modLink() {
      return this.getModLink(this.to);
    },
  },
  methods: {
    getModLink(link) {
      if (!this.isMultilang) {
        return null;
      }
      return getMultilangLink(this.getUrlPrefix, link);
    },
  },
};
